export const isConsultorio = (role) => {
    return role==='Consultorio';    
}